/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Phoneplaceholder1Inputs */

const he_profile_phoneplaceholder1 = /** @type {(inputs: Profile_Phoneplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזינו מספר טלפון`)
};

const en_profile_phoneplaceholder1 = /** @type {(inputs: Profile_Phoneplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter phone number`)
};

/**
* | output |
* | --- |
* | "Enter phone number" |
*
* @param {Profile_Phoneplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_phoneplaceholder1 = /** @type {((inputs?: Profile_Phoneplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Phoneplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_phoneplaceholder1(inputs)
	return en_profile_phoneplaceholder1(inputs)
});
export { profile_phoneplaceholder1 as "profile_phonePlaceholder" }